import { Upload } from "lucide-react";
import { Label } from "@/components/ui/label";

export function ScenarioMediaUpload({ mediaFile, onFileChange }) {
  return (
    <div>
      <Label className="text-zinc-500 text-xs uppercase tracking-wide mb-2 block">Video / Photo (optional)</Label>
      <label className="flex items-center gap-3 border border-dashed border-zinc-300 rounded-sm p-4 cursor-pointer hover:border-zinc-950 transition-colors">
        <Upload className="h-5 w-5 text-zinc-400" />
        <span className="text-sm text-zinc-500">{mediaFile ? mediaFile.name : "Upload content for this scenario"}</span>
        <input type="file" accept="video/*,image/*" onChange={(e) => onFileChange(e.target.files?.[0] || null)}
          data-testid="admin-scenario-media-upload-input" className="hidden" />
      </label>
    </div>
  );
}
